import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { CheckCircle, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { sendResetLink } from "../../store/actions/auth/resetPasswordAction";
import { useDispatch } from "react-redux";
import Loading from "../../shared/common/Loading";

const ForgetPasswordModal = ({ show, onHide }) => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (show) {
            setIsSuccess(false);
            setEmail("");
        }
    }, [show]);

    const handleSendResetLink = () => {
        dispatch(sendResetLink(email, setIsLoading)).then((res) => {
            if (res?.success) {
                setIsSuccess(true);
                setEmail("");
            }
        });
    };

    return (
        <Dialog open={show} onOpenChange={onHide}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Mail className="h-5 w-5" />
                        Reset Password
                    </DialogTitle>
                </DialogHeader>

                {isSuccess ? (
                    <div className="text-center space-y-4">
                        <div className="flex justify-center">
                            <CheckCircle className="w-12 h-12 text-green-500" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                Email Sent Successfully!
                            </h3>
                            <p className="text-gray-600 text-sm">
                                {"We've sent a password reset link to "}
                                <span className="font-medium">{email}</span>
                                {". Please check your email and click the link to reset your password."}
                            </p>
                        </div>
                        <Button onClick={onHide} className="w-full">
                            Got it
                        </Button>
                    </div>
                ) : (
                    <div className="flex flex-col gap-1">
                        <Label htmlFor="email" className="text-sm font-medium gap-0.5">
                            Email <span className="text-red-500">*</span>
                        </Label>
                        <Input
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            type="email"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="col-span-3"
                        />
                        <p className="text-[12px] text-muted-foreground">
                            We'll send you a link to reset your password.
                        </p>
                    </div>
                )}

                {!isSuccess && (
                    <DialogFooter className="gap-2">
                        <Button type="button" variant="outline" onClick={onHide}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            disabled={!email}
                            onClick={handleSendResetLink}
                        >
                            {isLoading ? (
                                <>
                                    <Loading width={16} height={16} color="#fff" />
                                    <span>Sending...</span>
                                </>
                            ) : (
                                "Send Reset Link"
                            )}
                        </Button>
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ForgetPasswordModal;
